import { GET_API_PATH } from "../../../constants"
import apiSetting from "../apiSetting"

const getCompanies = async (data) => {
    try {
        const queryParams = new URLSearchParams(data).toString();
        const response = await apiSetting({ method: 'GET', url: `${GET_API_PATH.GET_URL_COMPANIES}?${queryParams}`, data: null })
        return response
    } catch (e) {
        throw new Error(`網站錯誤 ! -> ${e}`)
    }
}

export { getCompanies }